<div class="text-center">
  <img
    src="assets/boat-animation.gif"
    style="display: flex; margin: 0 auto">
  <h5>{{ 'bvs.calculator.finished' | transloco }}</h5>
</div>
